module.exports = __webpack_public_path__ + "img/b8979.2410a758.png";